import z from 'zod';

export const WeighingNoteBillingStatusSchema = z.object({
    invoiceNumber: z.string().nullable(),
    orderNumber: z.string().nullable(),
    transportNumber: z.string().nullable(),
    invoiceReceiver: z.string(),
});

export const GetWeighingNoteBillingStatusResponseSchema = z.object({
    results: z.array(WeighingNoteBillingStatusSchema),
});

export const GetWeighingNoteBillingStatusParamsSchema = z.object({
    weighingNoteNumber: z.string(),
    netWeight: z.number().positive(),
    weightUnit: z.enum(['t', 'kg']),
    serviceDate: z.string(),
    licensePlate: z.string().optional(),
});

export type WeighingNoteBillingStatus = z.infer<typeof WeighingNoteBillingStatusSchema>;

export type GetWeighingNoteBillingStatusResponse = z.infer<typeof GetWeighingNoteBillingStatusResponseSchema>;

export type GetWeighingNoteBillingStatusParams = z.infer<typeof GetWeighingNoteBillingStatusParamsSchema>;
